module.exports = __webpack_public_path__ + "50962bc5215f63c2a4ce70eb5637acdf.png";